<template>
    <BaseCard>
        <div class="search-container">
            <BaseInput
                v-model="searchQuery"
                name="user-search"
                placeholder="Search for users by email or name..."
                type="search"
                class="search-input"
                @input="handleSearchInput"
            />
        </div>
        <la-users-table v-if="users && users.length > 0" :data="users"></la-users-table>
        <div v-else-if="isLoading">Loading users...</div>
        <div v-else>No users found. Debug: {{ users }}</div>

        <UsersPagination
            v-if="pagination.totalPages > 1"
            :current-page="pagination.currentPage"
            :total-pages="pagination.totalPages"
            :total-items="pagination.totalItems"
            :items-per-page="pagination.itemsPerPage"
            @page-change="handlePageChange"
        />
    </BaseCard>
</template>

<script>
import BaseCard from "@/components/BaseCard";
import BaseInput from "@/components/inputs/BaseInput";
import LaUsersTable from "@/components/users/UsersTable";
import UsersPagination from "@/components/users/UsersPagination";
import store from "@/store/store";
import { actionTypes as userActionTypes, getterTypes as userGetterTypes } from "@/store/Users/types";
import { computed, onMounted, ref } from "vue";

export default {
    name: "UsersCard",
    components: {
        BaseCard,
        BaseInput,
        LaUsersTable,
        UsersPagination,
    },
    setup() {
        const users = computed(() => store.getters[userGetterTypes.getUsers]);
        const pagination = computed(() => store.getters[userGetterTypes.getPagination]);
        const isLoading = computed(() => store.state.Users?.isLoading || false);
        const searchQuery = ref("");
        let searchTimeout = null;

        const loadUsers = async (page = 1, search = "") => {
            console.log("Loading users for page:", page, "with search:", search);
            try {
                const result = await store.dispatch(userActionTypes.getAllData, {
                    page,
                    searchQuery: search,
                });
                console.log("Action result:", result);
                console.log("Users loaded:", users.value);
                console.log("Pagination:", pagination.value);
            } catch (error) {
                console.error("Error loading users:", error);
            }
        };

        const handlePageChange = (page) => {
            console.log("Page change requested:", page);
            loadUsers(page, searchQuery.value);
        };

        const handleSearchInput = () => {
            if (searchTimeout) {
                clearTimeout(searchTimeout);
            }
            searchTimeout = setTimeout(() => {
                loadUsers(1, searchQuery.value);
            }, 300);
        };

        onMounted(async () => {
            console.log("UsersCard mounted, loading all users...");
            console.log("Available action types:", userActionTypes);
            console.log("Calling action:", userActionTypes.getAllData);
            await loadUsers(1);
        });

        return {
            users,
            pagination,
            isLoading,
            searchQuery,
            handlePageChange,
            handleSearchInput,
        };
    },
    provide() {
        return {
            setStatus: (name, hasError) => {
                // Prázdná implementace pro BaseInput validaci
                console.log(`Input ${name} validation status: ${hasError ? "error" : "ok"}`);
            },
        };
    },
};
</script>

<style lang="scss" scoped>
.search-container {
    margin-bottom: 1rem;
}

.search-input {
    max-width: 400px;
}

body.variant-performax {
    :deep(.search-input.base-input-container) {
        background: $white;
        border: 1px solid $px-purple;
        border-radius: $normal-radius;
        padding: 0.4rem 0.6rem;
    }

    :deep(.search-input.base-input-container input.base-input) {
        background: $white;
        border: none;
        color: $black;
    }

    :deep(.search-input.base-input-container input.base-input::placeholder) {
        color: rgba($px-purple, 0.6);
    }
}
</style>
